import { A4uDraw as IconComponent } from '@adobe/react-spectrum-workflow/dist/Draw.js';
import { Icon } from '@react-spectrum/icon';
import React from 'react';
export default function Draw(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}